import { render, staticRenderFns } from "./mergeFee.vue?vue&type=template&id=698e62e0"
import script from "./mergeFee.vue?vue&type=script&lang=js"
export * from "./mergeFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports